module.exports = __webpack_public_path__ + "media/assets/icons/partners-748c601d719469dbc861f97dcc112956.png";